import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

interface ProtectedRouteProps {
  children: JSX.Element;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { isAuthenticated, token } = useSelector((state: any) => state.auth);
  return isAuthenticated && token ? children : <Navigate to="/" replace />;
};

export default ProtectedRoute;
